import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Vant from 'vant'
import 'vant/lib/index.css'
import 'amfe-flexible'
import dataV from '@jiaminghi/data-view'
import Color from '@/style/color.scss' // 引入主scss变量
import hls from 'videojs-contrib-hls'
import Http from './service/request.js'
import { wexinShare, hideShare, getCode, isWechatOrAlipayBrowser, pcNextHanlde, isIos, mainWebsite, refreshShare } from '@/utils/wechatJsSdk'
import VerifyIdentity from '@/utils/VerifyIdentity.js'
import { GetParam, buildUrl } from '@/utils/getParam.js'
import { getGuestId, getLogin, loginAsGuest } from '@/api/info'
import { setStore } from '@/utils/setStore'
import navigateBack from '@/utils/navigate'
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore'
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter'
import weekOfYear from 'dayjs/plugin/weekOfYear'
import 'dayjs/locale/zh-cn'
moment.locale('zh-cn')
import { Lazyload } from 'vant'
import moment from 'dayjs'
moment.extend(isSameOrBefore)
moment.extend(isSameOrAfter)
moment.extend(weekOfYear)

import VueLuckyCanvas from '@lucky-canvas/vue'
Vue.use(VueLuckyCanvas)
Vue.use(dataV)
Vue.prototype.$Http = Http // 把Http挂载到vue 实例上   全局都可以用
Vue.prototype.$setvuex = setStore // 把Http挂载到vue 实例上  全局都可以用
Vue.use(hls) // 要播放hls流,
Vue.prototype.$imgurl = process.env.VUE_APP_IMG_URL
Vue.prototype.$Color = Color // 将scss变量挂载到全局
Vue.prototype.$VerifyIdentity = VerifyIdentity // 将scss变量挂载到全局
Vue.prototype.$navigateBack = navigateBack // 将scss变量挂载到全局
Vue.prototype.$moment = moment
Vue.prototype.$wexinShare = wexinShare
Vue.prototype.$hideShare = hideShare

Vue.config.productionTip = false
Vue.use(Vant)
Vue.use(Lazyload)
Vue.config.ignoredElements = ['wx-open-subscribe', 'wx-open-launch-weapp']

router.afterEach((to, from) => {
  // WeChat PC/移动端在单页应用中需要在路由变化后刷新分享配置，保证 link 为当前地址
  const ua = navigator.userAgent || ''
  if (/MicroMessenger/i.test(ua)) {
    // 可根据路由元信息选择性跳过
    if (to.meta && to.meta.share !== false) {
      refreshShare()
    }
  }
})
router.beforeEach(async (to, from, next) => {
  // 当分享链接为根路径并带有 `path` 参数时，优先还原到目标路由
  if (to.query && to.query.path) {
    try {
      const target = decodeURIComponent(to.query.path)
      if (typeof target === 'string' && target.length > 0) {
        // 避免循环：如果已经在目标路由则不再跳转
        const withoutHash = target
        if (to.fullPath !== withoutHash) {
          next(withoutHash)
          return
        }
      }
    } catch (e) {
      // 解码失败则继续原流程
    }
  }

  // 缓存当前路径到sessionStorage
  sessionStorage.setItem('currentPath', to.fullPath)

  if (to.meta.isTitle !== false) {
    // 默认标题
    document.title = process.env.VUE_APP_NAME
    if (to.meta.title) {
      document.title = to.meta.title
    }
  } else {
    document.title = to.query.name
  }

  if (mainWebsite(to, from, next) === true) {
    return
  }
  pcNextHanlde(to, from, next)

  if (mainWebsite(to, from, next) === true) {
    return
  }
  pcNextHanlde(to, from, next)

  // 在main.js里判断是否是ios和vuex保存的这个url是否为空，为空则存入当前url：
  if (isIos() && store.state.wxSignUrl == '') {
    store.commit('setWechatSignUrl', process.env.VUE_APP_BASE_Url + to.fullPath)
  }

  const token = store.state.token

  if (to.query.next === 'pc' || globalGetQueryParam('next') === 'pc') {
    next()
    return
  }

  if (isWechatOrAlipayBrowser() && to.path == '/goodDetails') {
    // 从首页，商品列表也，分类页，收藏夹，商家详情点击进入商品详
    // const routerList = []
    if (from.name !== null) {
      // 查询是是否登錄
      if (store.state.userInfo?.id) {
        next()
      } else {
        // 記錄要去的路由
        setStore('toPageUrl', to.fullPath)
        setStore('longDialogShow', true)
        return
      }
    }
  }
  // 已登录
  if (token) {
    next()
    return
  } else if (to.path == '/settoken' || to.path == '/auth-callback' || to.path == '/login') {
    // 白名单路由：直接放行
    next()
    return
  }
  // 未登录且不是微信和支付宝浏览器（PC） || 开发地址
  else if (!token && !(isWechatOrAlipayBrowser())) {
    setStore('token', '');
    setStore('userInfo', {});

    const guestId = to.query.guestId;
    const guestLogin = to.query.guestLogin;

    const handleGuestLogin = (credentials) => {
      getGuestId(credentials).then((res1) => {
        if (res1.code === 200) {
          loginAsGuest({ guestId: res1.data }).then((res2) => {
            if (res2.code === 200) {
              setStore("token", res2.data.token);
              setStore("userInfo", res2.data.user);
              // this.$toast({
              //   message: "登录成功",
              //   duration: 3000,
              //   onClose: () => location.reload(),
              // });
            }
          });
        } else {
          this.$dialog.alert({
            message: '登录失败',
            confirmButtonText: '知道了'
          });
        }
      });
    };

    if (guestLogin) {
      handleGuestLogin({ password: guestLogin });
    } else if (guestId) {
      handleGuestLogin({ guestId: guestId });
    } else {
      setStore('longDialogShowPC', true);
    }

    next();
    return;
  }


  // 未登录
  const query = GetParam()

  // 【凭证拦截】如果 URL 中带有 ticket，说明是从认证中心跳回来的，交给 AuthCallback 处理
  if (query.ticket) {
    console.log('检测到 ticket，准备跳转至 AuthCallback 处理...')
    // 保存当前路径，以便登录成功后跳回 (排除 ticket 等参数)
    const redirectPath = to.path === '/login' ? '/' : to.fullPath.split('?')[0]
    sessionStorage.setItem('auth_redirect', redirectPath)
    next({ path: '/auth-callback', query: { ticket: query.ticket } })
    return
  }

  // 使用当前路径（不带参数）作为基础地址进行构建，依靠buildUrl重新拼接干净的参数
  const href = buildUrl(window.location.origin + window.location.pathname)

  // 【静默登录优先策略】
  if (!query.code) {
    // 没有code，需要去微信授权
    // 优先使用静默授权（snsapi_base），不需要用户确认
    console.log('未登录且无code，开始静默授权流程...')
    getCode(href, 'snsapi_base') // 静默授权
  } else {
    // 有code，用code换取用户信息
    const data = {
      code: query.code,
      source: 'ZHQQ',
      scope: query.state || 'snsapi_base', // 默认静默授权
      access: query.access ? query.access : 'SELF'  // 自己平台(默认，可不传)：SELF，中山通：ZST
    }

    // 下面是我根据我实际业务场景编写的，主要是根据code获取个人信息保存。授权登录走到这一步基本就做完了
    getLogin(data).then(res => {
      setStore('codeSUM', store.state.codeSUM + 1)
      if (res.code == 200) {
        setStore('token', res.data.token) // 保存token

        // 【关键判断：如果是新用户，需要授权登录】
        if (res.data.base_newuser) {
          console.log('检测到新用户，需要授权登录获取用户信息')
          // 新用户：需要跳转到授权登录页面（snsapi_userinfo）
          // 清除静默授权的token，避免误以为已登录
          setStore('token', '')

          // 【防止循环跳转】检查当前是否已经在登录页
          if (to.path === '/login') {
            console.log('已在登录页，直接放行，由login.vue的mounted处理')
            next()
          } else {
            // 不在登录页，跳转到登录页
            // 注意：不要带code参数，避免登录页检测到code又执行getLogin
            console.log('跳转到登录页进行授权登录')
            next({ path: '/login', query: { redirect: to.fullPath } })
          }
        } else {
          // 老用户：静默登录成功
          console.log('老用户静默登录成功')
          setStore('setTabbarShow', true)
          setStore('userInfo', res.data.user)
          setStore('openid', res.data.wechat.id)
          setStore('longDialogShow', false)
          next()
        }
      } else {
        // 【登录失败处理】
        console.error('静默登录失败:', res.code, res.message)

        if (res.code == 401) { // 登录过期
          setStore('token', '')
          setStore('userInfo', {})
          setStore('openid', '')
          localStorage.removeItem('token')
          localStorage.removeItem('userInfo')
          localStorage.removeItem('openid')
        }

        // ❌ 不再重试getCode，避免反复跳转！
        // code只能使用一次，失败说明code无效或用户不存在
        // 直接跳转到授权登录页面
        console.error('静默授权失败，跳转到授权登录页')
        setStore('codeSUM', 0) // 重置计数器
        next({ path: '/login', query: { redirect: to.fullPath.split('?')[0] } }) // 移除query参数
      }
    }).catch((error) => {
      // 【异常处理】
      console.error('静默登录异常:', error)

      // ❌ 不再重试getCode，避免反复跳转！
      // 直接跳转到授权登录页面
      console.error('静默授权异常，跳转到授权登录页')
      setStore('codeSUM', 0) // 重置计数器
      next({ path: '/login', query: { redirect: to.fullPath.split('?')[0] } }) // 移除query参数
    })
  }
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
